import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/laugh-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM389.4 397.4C351.6 435.2 301.4 456 248 456S144.4 435.2 106.6 397.4C68.8 359.6 48 309.4 48 256S68.8 152.4 106.6 114.6C144.4 76.8 194.6 56 248 56S351.6 76.8 389.4 114.6C427.2 152.4 448 202.6 448 256S427.2 359.6 389.4 397.4zM328 164C302.3 164 272.1 180.9 268.1 206.1 266.4 217.3 279.6 224.3 287.9 216.9L297.4 208.4C312.2 195.2 343.6 195.2 358.4 208.4L367.9 216.9C376.4 224.3 389.5 217.2 387.7 206.1 383.9 180.9 353.7 164 328 164zM168 224C185.7 224 200 209.7 200 192S185.7 160 168 160 136 174.3 136 192 150.3 224 168 224zM362.4 288H133.6C125.4 288 119.1 295 120.1 303 127.6 362.2 179 408 241.2 408H254.8C317 408 368.4 362.2 375.9 303 376.9 295 370.6 288 362.4 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/laugh-wink.js
// module id = jP8E
// module chunks = 144